import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const EmptyState = ({ 
  icon: Icon, 
  title, 
  description, 
  actionLabel, 
  onAction, 
  secondaryActionLabel,
  onSecondaryAction,
  className = ""
}) => {
  const { t } = useLanguage();

  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center animate-in fade-in duration-700 ${className}`}>
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="relative mb-8"
      >
        <div className="absolute inset-0 bg-primary/20 blur-[50px] rounded-full animate-pulse" />
        <div className="relative w-24 h-24 rounded-[2rem] bg-slate-900 border border-white/10 flex items-center justify-center text-primary shadow-2xl">
          <Icon size={48} strokeWidth={1.5} />
        </div>
      </motion.div>

      <div className="max-w-md space-y-4 relative z-10">
        <h2 className="text-3xl font-display font-black text-slate-100 italic tracking-tight">
          {title}
        </h2>
        <p className="text-slate-500 text-base leading-relaxed font-medium">
          {description}
        </p>
      </div>

      {(actionLabel || secondaryActionLabel) && (
        <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
          {actionLabel && (
            <button
              onClick={onAction}
              className="px-8 py-4 bg-primary text-white rounded-[1.25rem] font-black uppercase tracking-widest text-xs hover:bg-blue-600 transition-all shadow-[0_10px_25px_-5px_rgba(37,99,235,0.4)] hover:scale-105 active:scale-95"
            >
              {actionLabel}
            </button>
          )}
          {secondaryActionLabel && (
            <button
              onClick={onSecondaryAction}
              className="px-8 py-4 bg-white/5 text-slate-300 border border-white/10 rounded-[1.25rem] font-black uppercase tracking-widest text-xs hover:bg-white/10 transition-all hover:scale-105 active:scale-95"
            >
              {secondaryActionLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
